/* Register the Phase 1 service worker.
 * Gated behind:
 *   1. window.__PWA_ENABLED__  (set from index.html based on backend `pwa_enabled` flag)
 *   2. `'serviceWorker' in navigator` support
 *   3. non-localhost origin OR ?pwa=1 dev override
 *
 * Emits a global `pwa:update` event so the app can show a "new version" toast.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  const forceDev    = new URLSearchParams(window.location.search).get("pwa") === "1";
  const enabled     = window.__PWA_ENABLED__ === true;

  if (!enabled) return;
  if (isLocalhost && !forceDev) return;

  const url = "/service-worker.js";

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register(url, { scope: "/" });

      // Detect update
      if (reg.waiting) window.dispatchEvent(new CustomEvent("pwa:update", { detail: reg }));

      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("pwa:update", { detail: reg }));
          }
        });
      });
    } catch (err) {
      // Never break the app — SW is optional
      // eslint-disable-next-line no-console
      console.warn("[PWA] Service worker registration failed:", err);
    }
  });
}

export function unregisterServiceWorker() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
  }
}
